export default {
    logs: state => state.logs
}
